import { useEffect, useRef } from "react";

const activityEvents = ["mousemove", "keydown", "scroll"];

const useActivity = (active: () => void, idle: () => void, activeInterval: number = 1000, idleInterval: number = 1000, idleTime: number = 60000): void => {
    const lastActivityTimeRef = useRef<number>(null);
    const idleTimerRef = useRef<ReturnType<typeof setTimeout>>();

    function setIdleTimeout(interval: number): void {
        idleTimerRef.current = setTimeout(() => {
            idle();
            setIdleTimeout(idleInterval);
        }, interval);
    }

    function clearIdleTimeout(): void {
        if (idleTimerRef.current)
            clearTimeout(idleTimerRef.current);
    }

    function refreshIdleTimeout(): void {
        clearIdleTimeout();
        setIdleTimeout(idleTime);
    }

    useEffect(() => {
        setIdleTimeout(idleTime);

        const handleActivity = (): void => {
            refreshIdleTimeout();

            const now = Date.now();
            if (lastActivityTimeRef === null || (now - lastActivityTimeRef.current >= activeInterval)) {
                lastActivityTimeRef.current = now;
                active();
            }
        };

        activityEvents.forEach(event => window.addEventListener(event, handleActivity));

        return () => {
            activityEvents.forEach(event => window.removeEventListener(event, handleActivity));
            clearIdleTimeout();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, idle, activeInterval, idleInterval, idleTime]);
};

export default useActivity;
